export enum AVAILABILITY {
  ACTIVELY_LOOKING = 'ACTIVELY_LOOKING',
  OPEN = 'OPEN',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}
